import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, color, ...props }: React.ComponentProps<"textarea">) {
  const getTextareaColorClasses = () => {
    if (!color) return 'border-input focus-visible:border-ring focus-visible:ring-ring/50'

    switch (color) {
    case 'blue-500':
      return 'border-input focus:outline-none focus:border-blue-500 focus:ring-0 focus:shadow-none'
    case 'red-500':
      return 'border-input focus:outline-none focus:border-red-500 focus:ring-0 focus:shadow-none'
    case 'pink-500':
      return 'border-input focus:outline-none focus:border-pink-500 focus:ring-0 focus:shadow-none'
    case 'purple-500':
      return 'border-input focus:outline-none focus:border-purple-500 focus:ring-0 focus:shadow-none'
    case 'green-500':
      return 'border-input focus:outline-none focus:border-green-500 focus:ring-0 focus:shadow-none'
    case 'amber-500':
      return 'border-input focus:outline-none focus:border-amber-500 focus:ring-0 focus:shadow-none'
    default:
      return 'border-input focus:outline-none focus:border-blue-500 focus:ring-0 focus:shadow-none'
    }
  }

  const baseTextareaClasses = `flex w-full rounded-md border bg-background sm:text-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 transition-colors min-h-24 px-3 py-2 text-base md:text-sm ${getTextareaColorClasses()}`

  return (
    <textarea
      data-slot="textarea"
      className={cn(
        baseTextareaClasses,
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
